import { useEffect } from "react";

const TrustedShopsBadge = () => {
  useEffect(() => {
    const scriptId = "ts-badge-script";
    const interactionEvents = ["pointerdown", "touchstart", "keydown", "scroll"];

    const removeInteractionListeners = () => {
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, loadTrustedShops);
      });
    };

    function loadTrustedShops() {
      removeInteractionListeners();

      if (document.getElementById(scriptId)) return;

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "//widgets.trustedshops.com/js/X8BEC543A1A07D4214B91255D1AC72EF6.js";
      script.async = true;
      script.charset = "UTF-8";
      const config = {
        "data-desktop-y-offset": "10",
        "data-mobile-y-offset": "0",
        "data-desktop-disable-reviews": "false",
        "data-desktop-enable-custom": "false",
        "data-desktop-position": "right",
        "data-desktop-custom-width": "156",
        "data-desktop-enable-fadeout": "false",
        "data-disable-mobile": "false",
        "data-disable-trustbadge": "false",
        "data-mobile-custom-width": "156",
        "data-mobile-disable-reviews": "false",
        "data-mobile-enable-custom": "false",
        "data-mobile-position": "right",
        "data-color-scheme": "os-default"
      };

      Object.entries(config).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });

      document.body.appendChild(script);
    }

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, loadTrustedShops, {
        once: true,
        passive: true,
      });
    });

    return removeInteractionListeners;
  }, []);

  return null;
};

export default TrustedShopsBadge;
